import React from "react";
import Plan from "./Plan";

const Group77 = () => {
      return(
            <div className="plan-parent">
                  <Plan class="plan" name="Basic"colorType="parent" buttonType="start-free-trial-wrapper" />
                  <Plan class="plan1" name="Basic"colorType="parent" buttonType="start-free-trial-wrapper" />
                  <Plan class="plan2" name="Premium" colorType="container" buttonType="start-free-trial-frame" />
            </div>
      );
};

export default Group77;